import styled, { css } from 'styled-components';
import { Title } from '@lux/title';
import { mediaMinWidth } from '@lux/templates';
import { BackgroundColor, FunctionColor, Spacer } from '@lux/tokens';

import { Screen, screenSmallerThan } from '@client/styles/styled-components/breakpoints';
import { Grid } from '@lux/grid';

export const OuterWrapper = styled.main`
    background-color: ${BackgroundColor.mylounge};
    position: relative;

    .grid-page-layout {
        ${screenSmallerThan(Screen.smallTablet)} {
            padding-left: 0;
            padding-right: 0;
        }
    }
`;

export const Wrapper = styled.section<{ $isLastContainer?: boolean }>`
    position: relative;
    background-color: ${BackgroundColor.mylounge};
    ${({ $isLastContainer }) =>
        $isLastContainer &&
        css`
            padding-bottom: 35px;
        `};
`;

export const InlineFlashMessage = styled.div`
    margin: 0 3% 15px;
`;

export const UpcomingTitle = styled(Title)`
    margin-top: ${Spacer.XL};
    margin-bottom: ${Spacer.M};
    padding: 0 14px;
    ${mediaMinWidth.sm} {
        padding: 0;
    }
`;

export const MoreCampaignTitle = styled(Title)`
    margin-top: ${Spacer.M};
    text-align: center;
`;

export const MoreCampaignsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${Spacer.L};
    margin: ${Spacer.M} ${Spacer.S} ${Spacer.L};
`;

export const GREWrapper = styled.div`
    margin-top: -12.5rem;
    padding-top: ${Spacer.XL};
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${Spacer.L};
    overflow: hidden;
`;

export const GREContentWrapper = styled.div`
    padding: 0 ${Spacer.S};
    width: 100%;
    isolation: isolate;
`;

export const GridWithBackground = styled(Grid)`
    background-color: ${FunctionColor.function0};
    padding-bottom: ${Spacer.M};
    margin-bottom: ${Spacer.S};
`;
